import { useRef, useState, useEffect } from "react";
import "./ArtistLoading.css";

function ArtistLoading() {
  const windowRef = useRef(null);
  const offset = useRef({ x: 0, y: 0 });

  const [progress, setProgress] = useState(0);
  const [isOpen, setIsOpen] = useState(true);

  /* ======================
     Fake loading animation (stops at 100%)
  ====================== */
  useEffect(() => {
    if (progress >= 100) return;

    const interval = setInterval(() => {
      setProgress((prev) => Math.min(prev + 1, 100));
    }, 90);

    return () => clearInterval(interval);
  }, [progress]);

  /* ======================
     Drag helpers
  ====================== */
  const startDrag = (clientX, clientY) => {
    const rect = windowRef.current.getBoundingClientRect();
    offset.current = {
      x: clientX - rect.left,
      y: clientY - rect.top,
    };
  };

  const moveWindow = (clientX, clientY) => {
    windowRef.current.style.left = `${clientX - offset.current.x}px`;
    windowRef.current.style.top = `${clientY - offset.current.y}px`;
  };

  const stopMouseDrag = () => {
    document.removeEventListener("mousemove", onMouseMove);
    document.removeEventListener("mouseup", stopMouseDrag);
  };

  const stopTouchDrag = () => {
    document.removeEventListener("touchmove", onTouchMove);
    document.removeEventListener("touchend", stopTouchDrag);
  };

  const onMouseDown = (e) => {
    startDrag(e.clientX, e.clientY);
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", stopMouseDrag);
  };

  const onMouseMove = (e) => {
    moveWindow(e.clientX, e.clientY);
  };

  const onTouchStart = (e) => {
    const touch = e.touches[0];
    startDrag(touch.clientX, touch.clientY);
    document.addEventListener("touchmove", onTouchMove, { passive: false });
    document.addEventListener("touchend", stopTouchDrag);
  };

  const onTouchMove = (e) => {
    e.preventDefault();
    const touch = e.touches[0];
    moveWindow(touch.clientX, touch.clientY);
  };

  if (!isOpen) return null;

  return (
    <div
      ref={windowRef}
      className="loading-window"
      style={{ top: "400px", left: "200px" }}
    >
      <div
        className="loading-header"
        onMouseDown={onMouseDown}
        onTouchStart={onTouchStart}
      >
        <div className="window-buttons">
          <span className="button red" onClick={() => setIsOpen(false)} />
          <span className="button yellow" />
          <span className="button green" />
        </div>
        <span className="terminal-title">booting.exe</span>
      </div>

      <div className="loading-body">
        {/* Loading Label */}
        <div className="loading-label">
          {progress < 100
            ? `loading favorite book of 2025... ${progress}%`
            : "favorite book of 2025:"}
        </div>

        {/* Progress Bar */}
        <div className="progress-track">
          <div className="progress-fill" style={{ width: `${progress}%` }} />
        </div>

        {/* Show book title when complete */}
        {progress === 100 && (
          <div className="favorite-book">
            eros the bittersweet - anne carson
          </div>
        )}
      </div>
    </div>
  );
}

export default ArtistLoading;
